//#region src/shared/utils/invariant.ts
const prefix = "Invariant failed";
function invariant(condition, message) {
	if (condition) return;
	const provided = typeof message === "function" ? message() : message;
	const value = provided ? `${prefix}: ${provided}` : prefix;
	throw new Error(value);
}

//#endregion
export { invariant as default };
//# sourceMappingURL=invariant.js.map